export class Section {
	id!: string;
	name!: string;
}
